import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MenuComponent, MenuItemComponent, MenuTriggerDirective } from '@siemens/component-lib';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ThemeService } from '../../services/theme.service';
import { AuthService } from '../../../auth/services/auth.service';
import { Router } from '@angular/router';
import { UserProfileComponent } from '../user-profile/user-profile.component';

@Component({
    selector: 'app-header-menu',
    imports: [MenuTriggerDirective, MenuComponent, MenuItemComponent, TranslatePipe, UserProfileComponent],
    templateUrl: './header-menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderMenuComponent implements OnInit {
    protected authService = inject(AuthService);
    private translate = inject(TranslateService);
    private themeService = inject(ThemeService);
    private router = inject(Router);

    ngOnInit(): void {
        this.initializeThemeAndLanguageFromLocalStorage();
    }

    protected changeLang(langCode: string): void {
        this.translate.use(langCode);
        localStorage.setItem('language', JSON.stringify(langCode));
    }

    protected setTheme(mode: 'dark' | 'light'): void {
        this.themeService.setTheme(mode);
        localStorage.setItem('theme', JSON.stringify(mode));
    }

    protected isRouterPathUnauthorized(): boolean {
        return this.router.url === '/unauthorized';
    }

    private initializeThemeAndLanguageFromLocalStorage(): void {
        this.initializeTheme();
        this.initializeLanguage();
    }

    private initializeTheme() {
        try {
            const storedTheme = localStorage.getItem('theme');
            const theme: 'dark' | 'light' | null = storedTheme ? JSON.parse(storedTheme) : null;
            this.setTheme(theme === 'dark' || theme === 'light' ? theme : 'dark');
        } catch (_: unknown) {
            this.setTheme('dark');
        }
    }

    private initializeLanguage(): void {
        try {
            const storedLang = localStorage.getItem('language');
            const lang: 'en' | 'de' | null = storedLang ? JSON.parse(storedLang) : null;
            this.changeLang(lang === 'en' || lang === 'de' ? lang : 'en');
        } catch (_: unknown) {
            this.changeLang('en');
        }
    }
}
